import React, { useState } from 'react';
import { Flag, Loader2 } from 'lucide-react';
import api from '@/lib/axios';
import { track } from '@/lib/analytics';

const MOTIVOS = [
  ['fraude', 'Possível fraude'],
  ['informacao_falsa', 'Informação falsa'],
  ['viatura_inexistente', 'Viatura inexistente'],
  ['contacto_suspeito', 'Contacto suspeito'],
  ['ofensivo', 'Conteúdo ofensivo'],
  ['dados_pessoais', 'Dados pessoais sem autorização'],
  ['duplicado', 'Anúncio duplicado'],
  ['preco_enganador', 'Preço enganador'],
  ['outro', 'Outro'],
];

export default function ReportListingModal({ listingId, onClose }) {
  const [motivo, setMotivo] = useState('');
  const [descricao, setDescricao] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');

  const submit = async () => {
    if (!motivo) { setErr('Escolha um motivo.'); return; }
    setLoading(true);
    setErr('');
    try {
      await api.post(`/marketplace/publicacoes/${listingId}/denuncia`, { motivo, descricao, email });
      track('report_listing', { publicacao_id: listingId, motivo });
      setDone(true);
    } catch (e) {
      setErr(e.response?.data?.detail || 'Erro ao enviar denúncia.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[95] flex items-center justify-center bg-black/40 p-4" data-testid="report-modal">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl">
        <div className="mb-3 flex items-center justify-between">
          <h4 className="inline-flex items-center gap-2 text-lg font-bold text-slate-900">
            <Flag className="h-5 w-5 text-red-600" /> Denunciar anúncio
          </h4>
          <button onClick={onClose} className="rounded-lg border border-slate-300 px-2 py-1 text-xs" data-testid="report-close">Fechar</button>
        </div>

        {done ? (
          <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800" data-testid="report-success">
            Denúncia recebida. Obrigado por ajudar a manter o Marketplace seguro.
            <button onClick={onClose} className="mt-3 block rounded-lg bg-emerald-600 px-4 py-2 text-xs font-bold text-white">Fechar</button>
          </div>
        ) : (
          <div className="grid gap-3">
            <select className="rounded-lg border border-slate-300 px-3 py-2 text-sm" value={motivo} onChange={(e) => setMotivo(e.target.value)} data-testid="report-motivo">
              <option value="">— Escolha o motivo —</option>
              {MOTIVOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <textarea className="rounded-lg border border-slate-300 px-3 py-2 text-sm" rows={3} placeholder="Explique o problema (opcional)" value={descricao} onChange={(e) => setDescricao(e.target.value)} data-testid="report-descricao" />
            <input className="rounded-lg border border-slate-300 px-3 py-2 text-sm" placeholder="O seu email (opcional)" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="report-email" />
            {err && <p className="text-xs font-semibold text-red-600" data-testid="report-error">{err}</p>}
            <button onClick={submit} disabled={loading} className="inline-flex items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-bold text-white transition hover:bg-red-700 disabled:opacity-60" data-testid="report-submit">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null} Enviar denúncia
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
